import {INIT_APP, INIT_PROTOCOL} from '../../actions/chat-root/index';

const initialState = {
  title: 'WebPlugin',
  debugFunc: () => {},
  fullFunc: () => {},
  closeFunc: () => {},
  protocol: () => {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case INIT_APP:
      return initApp(state, action);
    case INIT_PROTOCOL:
      return initProtocol(state, action.protocol);
  }
  return state;
}

function initApp(state, params) {
  return {
    ...state,
    title: params.title || state.title,
    debugFunc: params.debugFunc || state.debugFunc
  };
}

function initProtocol(state, protocol) {
  return {...state, protocol: protocol};
}




// WEBPACK FOOTER //
// ./src/reducers/chat-root/index.js